export const categories = [
  {
    slug: 'guobiao-majiang',
    name: '国标麻将',
    description: '国标麻将是中国最广泛流行的麻将玩法，采用国际通用规则，包含81种番种。适合竞技比赛和日常娱乐，是麻友入门首选。',
    icon: 'ri-book-marked-line',
    playerCount: '4人',
    difficulty: '中等',
    popularity: 98,
    imageSeq: 'cat-guobiao',
  },
  {
    slug: 'sichuan-majiang',
    name: '四川麻将',
    description: '四川麻将又称血战到底，打法刺激，去除字牌和风牌，讲究速战速决。流行于四川、重庆等地，是麻将中最具地方特色的玩法之一。',
    icon: 'ri-fire-line',
    playerCount: '4人',
    difficulty: '较难',
    popularity: 95,
    imageSeq: 'cat-sichuan',
  },
  {
    slug: 'guangdong-majiang',
    name: '广东麻将',
    description: '广东麻将打法灵活多变，注重策略与技巧，包含推倒胡、鸡平胡等多种变体。在广东及港澳地区极其流行。',
    icon: 'ri-vip-crown-line',
    playerCount: '4人',
    difficulty: '中等',
    popularity: 90,
    imageSeq: 'cat-guangdong',
  },
  {
    slug: 'xueliu-chenghe',
    name: '血流成河',
    description: '血流成河是近年大热的麻将玩法，胡牌后仍可继续摸牌胡牌，直至牌墙摸完。节奏快、刺激性强，深受年轻玩家喜爱。',
    icon: 'ri-water-flash-line',
    playerCount: '4人',
    difficulty: '较易',
    popularity: 92,
    imageSeq: 'cat-xueliu',
  },
  {
    slug: 'changsha-majiang',
    name: '长沙麻将',
    description: '长沙麻将讲究快、准、狠，胡牌方式多样，允许抢杠胡和海底捞月。在湖南地区拥有广泛的群众基础。',
    icon: 'ri-compasses-line',
    playerCount: '4人',
    difficulty: '较难',
    popularity: 85,
    imageSeq: 'cat-changsha',
  },
  {
    slug: 'dongbei-majiang',
    name: '东北麻将',
    description: '东北麻将规则简洁明快，去除花牌简化流程，强调牌型的纯粹与计算的精准。在东北三省广受欢迎。',
    icon: 'ri-snowy-line',
    playerCount: '4人',
    difficulty: '较易',
    popularity: 82,
    imageSeq: 'cat-dongbei',
  },
];

export const articles = [
  {
    slug: 'majiang-rumen-jiaocheng',
    title: '麻将入门教程：零基础学会打麻将',
    excerpt: '想学打麻将但不知从何入手？这篇麻将入门教程从认识牌型到基本规则，手把手教你从零开始学麻将，让你快速上手成为麻将高手。',
    category: '入门攻略',
    readTime: '8分钟',
    publishDate: '2026-08-01',
    author: '麻将君',
    imageSeq: 'article-1',
  },
  {
    slug: 'guobiao-majiang-fanzhong',
    title: '国标麻将81种番种详解与实战技巧',
    excerpt: '国标麻将的81种番种是竞技麻将的核心。本文详细解读各类番种的组成、计分规则及实战运用技巧，助你提升麻将水平。',
    category: '进阶技巧',
    readTime: '12分钟',
    publishDate: '2026-07-28',
    author: '牌桌老手',
    imageSeq: 'article-2',
  },
  {
    slug: 'sichuan-majiang-xuezhan',
    title: '四川麻将血战到底玩法全攻略',
    excerpt: '四川麻将的血战到底玩法以其刺激的规则著称。本文详细介绍四川麻将的基本规则、胡牌技巧及常见策略，带你领略川麻魅力。',
    category: '玩法攻略',
    readTime: '10分钟',
    publishDate: '2026-07-25',
    author: '川麻达人',
    imageSeq: 'article-3',
  },
  {
    slug: 'majiang-gaoji-jiqiao',
    title: '麻将高级技巧：听牌策略与防守反击',
    excerpt: '想要从麻将新手进阶为高手？掌握听牌策略与防守反击技巧是关键。本文分享资深玩家的实战经验，帮你提升胜率。',
    category: '进阶技巧',
    readTime: '15分钟',
    publishDate: '2026-07-20',
    author: '麻将君',
    imageSeq: 'article-4',
  },
  {
    slug: 'majiang-xinli-zhan',
    title: '麻将心理战：读牌、拆牌与对手分析',
    excerpt: '麻将不仅是运气的游戏，更是一场心理博弈。学会读牌、拆牌和分析对手的打牌习惯，让你在牌桌上占据心理优势。',
    category: '高手心得',
    readTime: '9分钟',
    publishDate: '2026-07-15',
    author: '心理牌手',
    imageSeq: 'article-5',
  },
  {
    slug: 'xueliu-chenghe-jiqiao',
    title: '血流成河玩法技巧：如何实现连胜',
    excerpt: '血流成河玩法节奏快、胡牌机会多。本文分享血流成河的核心策略和连胡技巧，助你在激烈的牌局中保持连胜。',
    category: '玩法攻略',
    readTime: '7分钟',
    publishDate: '2026-07-10',
    author: '血流高手',
    imageSeq: 'article-6',
  },
];

export const faqs = [
  {
    question: '麻将在线玩需要下载安装吗？',
    answer: '完全不需要！麻将在线玩是纯网页版麻将游戏，打开浏览器即可直接玩，无需下载任何软件或插件。支持电脑、平板和手机等多种设备。',
  },
  {
    question: '麻将在线玩完全免费吗？',
    answer: '是的，麻将在线玩平台上的所有玩法均完全免费，无隐藏收费，无需充值。我们致力于为麻将爱好者提供最便捷的免费在线麻将体验。',
  },
  {
    question: '支持哪些麻将玩法？',
    answer: '目前平台支持国标麻将、四川麻将、广东麻将、血流成河、长沙麻将、东北麻将等十余种主流玩法，后续还会不断新增更多地方麻将玩法。',
  },
  {
    question: '可以和朋友在线联机对战吗？',
    answer: '当然可以！麻将在线玩支持创建私人房间，邀请好友加入对战。同时也支持随机匹配，与来自全国各地的麻友切磋技艺。',
  },
  {
    question: '单机模式需要联网吗？',
    answer: '单机对战模式需要首次加载游戏资源，之后在网络不稳定的情况下也能正常游玩。不过建议在联网状态下游戏，以获得最佳体验。',
  },
  {
    question: '如何快速提升麻将水平？',
    answer: '建议从入门教程开始学习基本规则，然后通过单机模式练习手感，再逐步挑战多人对战。我们的攻略文章区也提供了大量实战技巧供您参考。',
  },
];